<template>
  <div class="grid gap-4 sm:max-w-[425px]">
    <div class="flex flex-col gap-4">
      <Button variant="light" size="lg" @click="signIn('github')">
        <img
          src="/public/img/providers/github.svg"
          class="w-6 h-6 mr-2 invert dark:invert-0"
        />
        {{ $t("auth.sign-in-with") }} GitHub
      </Button>

      <Button variant="light" size="lg" @click="signIn('google')">
        <img src="/public/img/providers/gmail.svg" class="w-6 h-6 mr-2" />
        {{ $t("auth.sign-in-with") }} Gmail
      </Button>
    </div>

    <Separator label="Or" class="my-2" />

    <LoginForm />
  </div>
</template>

<script setup lang="ts">
import { Separator } from "@/components/ui/separator";
import LoginForm from "./LoginForm.vue";

const { signIn } = useAuth();
</script>
